import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type State = {
  dropdownWorkstationId: string;
  /** Preview settings only: filters workstation dropdowns when set. */
  selectedGridId: string | undefined;
};

const initialState: State = {
  dropdownWorkstationId: "",
  selectedGridId: undefined
};

export const workstationConfigSlice = createSlice({
  name: "workstationConfig",
  initialState,
  reducers: {
    setDropdownWorkstationId(state, { payload }: PayloadAction<string>) {
      state.dropdownWorkstationId = payload;
    },
    setSelectedGridId(
      state,
      { payload }: PayloadAction<State["selectedGridId"]>
    ) {
      state.selectedGridId = payload;
    }
  },
  selectors: {
    selectDropdownWorkstationId: (state: State) => state.dropdownWorkstationId,
    selectSelectedGridId: (state: State) => state.selectedGridId
  }
});

export const { setDropdownWorkstationId, setSelectedGridId } =
  workstationConfigSlice.actions;

export const { selectDropdownWorkstationId, selectSelectedGridId } =
  workstationConfigSlice.selectors;
